<template>
    <v-container
        v-if="can('api.v1.notifications.index') && !!notificationsCount"
        class="mx-2 d-flex align-items-center"
    >
        <v-icon v-if="!notificationsCount">mdi-bell-ring-outline</v-icon>
        <v-menu v-else v-model="menu" bottom min-width="200px" offset-y :close-on-click="false">
            <template #activator="{ on }">
                <div v-if="newNotificationsCount" class="position-relative" :class="{ pulseBorder: disabled }">
                    <v-icon v-on="on">mdi-bell-ring-outline</v-icon>

                    <v-avatar
                        color="notifications"
                        size="22"
                        class="absolute-top-left"
                        style="border: 2px solid #f0f0f0 !important; cursor: pointer"
                        @click="menu = !menu"
                    >
                        <span class="white--text">{{ newNotificationsCount }}</span>
                    </v-avatar>
                </div>
                <v-icon v-else v-on="on">mdi-bell-ring-outline</v-icon>
            </template>
        </v-menu>
        <v-fade-transition>
            <v-card v-if="menu" class="notifications-modal" elevation="6">
                <v-card-title>
                    <v-icon color="#a5a5a5" small @click="menu = false">mdi-close</v-icon>
                    <h4>{{ t('default::title.notification') }}</h4>
                </v-card-title>
                <v-card-actions>
                    <v-btn small color="primary" text rounded @click="goTo('notifications.index')">{{
                        t('default::button.view.all')
                    }}</v-btn>
                    <v-btn small color="primary" :loading="loading" text rounded @click="markAllAsCompleted()">{{
                        t('notifications::button.mark_all_as_completed')
                    }}</v-btn>
                </v-card-actions>
                <v-list v-if="notifications" class="notifications" style="background-color: transparent !important">
                    <template v-for="(notification, index) in notifications">
                        <div :key="index" :class="notification.class || ''">
                            <div class="notification-wrap">
                                <div class="meta">
                                    <div v-if="notification.date" class="date">{{ notification.date }}</div>
                                    <div v-if="notification.created_by && notification.created_by.name" class="creator">
                                        {{ notification.created_by.name }}
                                    </div>
                                </div>
                                <div class="copy">
                                    <div v-if="notification.type" class="type">
                                        {{ t('notifications::types.' + notification.type) }}
                                    </div>
                                    <div v-if="notification.memo" class="memo">{{ notification.memo }}</div>
                                </div>
                                <div class="actions">
                                    <v-tooltip
                                        v-if="
                                            can('api.v1.notifications.complete') &&
                                            can('api.v1.requests.show') &&
                                            notification.status === 'new' &&
                                            !notification.type === 'record_changes'
                                        "
                                        top
                                        transition="v-fab-transition"
                                    >
                                        <template #activator="{ on, attrs }">
                                            <v-btn
                                                color="#00000060"
                                                icon
                                                :loading="loading"
                                                v-bind="attrs"
                                                small
                                                v-on="on"
                                                @click="markAsCompleted(notification)"
                                            >
                                                <v-icon>mdi-check-bold</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>{{ t('notifications::button.mark_as_completed') }}</span>
                                    </v-tooltip>
                                    <v-tooltip v-if="can('notifications.get')" top transition="v-fab-transition">
                                        <template #activator="{ on, attrs }">
                                            <v-btn
                                                color="#00000060"
                                                icon
                                                v-bind="attrs"
                                                small
                                                v-on="on"
                                                @click="preview(notification)"
                                            >
                                                <v-icon>mdi-eye</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>{{ t('notifications::button.details') }}</span>
                                    </v-tooltip>
                                </div>
                            </div>
                        </div>
                    </template>
                </v-list>
            </v-card>
        </v-fade-transition>
        <div>
            <notification-modal :dialog.sync="previewModal" @close-dialog="previewModal = false"></notification-modal>
        </div>
    </v-container>
</template>

<script>
let NotificationApprovalRequest = require(process.env.MIX_APP_ROOT +
    '/bgo/bgo-components/resources/js/mixins/Notification.js').default;
export default {
    name: 'NotificationComponent',
    components: {},
    mixins: [NotificationApprovalRequest],
    props: {
        color: {
            type: String,
            default: 'notifications',
        },
    },
    data() {
        return {
            menu: false,
            previewModal: false,
            disabled: false,
            isInitNotifications: false,
            oldCount: 0,
        };
    },
    computed: {
        notifications() {
            return this.$store.state.notifications.notifications;
        },
        newNotificationsCount() {
            return this.$store.state.notifications.new_notifications_count;
        },
        notificationsCount() {
            return this.$store.state.notifications.count;
        },
    },
    watch: {
        notificationsCount(newCount, oldCount) {
            this.oldCount = oldCount;

            if (!newCount) {
                this.$root.setAppOverLay(false);
            }
        },
        notifications(newNotifications) {
            this.prepareNotification(newNotifications);
            if (!this.isInitNotifications) {
                this.isInitNotifications = true;
                return;
            }

            if (this.oldCount > this.notificationsCount) return;

            this.disabled = true;
            setTimeout(
                function () {
                    this.disabled = false;
                }.bind(this),
                4000
            );
        },
        menu(modal) {
            this.$root.setAppOverLay(modal);
        },
    },
    created() {
        this.getNotifications();
    },
};
</script>

<style lang="scss" scoped>
.absolute-top-left {
    position: absolute;
    z-index: 9;
    top: -8px;
    right: -8px;
    span {
        font-size: 8px;
        font-weight: 500;
    }
}
.pulseBorder:after {
    content: '';
    display: block;
    height: 40px;
    width: 40px;
    position: absolute;
    top: -10px;
    left: -6px;
    right: 0;
    bottom: 0;
    animation: pulse 1s ease both 5;
    border-radius: 50%;
    border: 4px double #b6000f;
}
@keyframes pulse {
    0% {
        transform: scale(1);
        opacity: 1;
    }
    60% {
        transform: scale(1.3);
        opacity: 0.4;
    }
    100% {
        transform: scale(1.4);
        opacity: 0;
    }
}
</style>
